import React, { useMemo } from 'react';
import { Button, Title, useClassnames, type TStyle } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';
import { type FallbackRender } from '@sentry/react';

import { ErrorStack } from '#component/error-stack';

import style from './index.module.pcss';

type TFallbackRender = Parameters<FallbackRender>[0];

export interface IProps extends TFallbackRender {
    className?: string | TStyle
}

export const ErrorFallback = (props: IProps) => {
    const cn = useClassnames(style, props.className);
    const { t } = useTranslation();

    const elSubTitle = useMemo(() => {
        if(props.error instanceof Error) {
            return (
                <Title
                    tagName="h3"
                    children={props.error.message}
                />
            );
        }
    }, [props.error]);

    return (
        <div
            role="alert"
            className={cn('error-fallback')}
        >
            <div className={cn('error-fallback__content')}>
                <Title>{t('error-boundary.title')}</Title>
                {elSubTitle}
                <ErrorStack error={props.error} />
                <Button
                    presetStyle="primary"
                    type="button"
                    onClick={props.resetError}
                    children={t('error-boundary.try-again')}
                />
            </div>
        </div>
    );
};
